import { DatePipe } from "@angular/common";
import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "mobi-office-lib-time-period-bar",
  templateUrl: "./time-period-bar.component.html",
  styleUrl: "./time-period-bar.component.scss",
  standalone: false,
})
export class TimePeriodBarComponent {
  private readonly datePipe = inject(DatePipe);
  constructor() {}

  /**
   * Allow to select custom time in range
   */
  @Input() isCustomDatePicker: boolean = false;

  /**
   * Time Period should be in form of string array like  : ['Today', 'Yesterday', '7D', '1M', '1Y']
   */
  @Input() timePeriod: string[] = [];

  /**
   * Will accept the default selected value
   */
  @Input() model: string = "";

  @Output() modelChange = new EventEmitter<string>();
  @Output() dateEmitter = new EventEmitter<Int_Date>();

  private readonly currentDate = new Date();
  fromDate: string | Date = this.datePipe.transform(new Date(), "yyyy-MM-dd") || "";
  toDate: string | Date = this.datePipe.transform(new Date(), "yyyy-MM-dd") || "";
  range = new FormGroup({
    start: new FormControl<Date | string | null>(null),
    end: new FormControl<Date | string | null>(null),
  });

  onSelectTime(item: string) {
    this.model = item;
    this.modelChange.emit(item);

    switch (this.model?.toUpperCase()) {
      case "TODAY":
        this.fromDate = new Date(this.currentDate);
        this.toDate = new Date(this.currentDate);
        break;
      case "YESTERDAY":
        this.fromDate = new Date(this.currentDate);
        this.fromDate.setDate(this.currentDate.getDate() - 1);
        this.toDate = new Date(this.currentDate);
        this.toDate.setDate(this.currentDate.getDate() - 1);
        break;

      default:
        // eslint-disable-next-line no-case-declarations
        const match = item.match(/^(\d+)([DMY])$/);
        if (match) {
          const amount = parseInt(match[1], 10);
          const unit = match[2]?.toUpperCase();
          this.fromDate = new Date(this.currentDate);

          if (unit === "D") {
            this.fromDate.setDate(this.currentDate.getDate() - amount);
          } else if (unit === "M") {
            this.fromDate.setMonth(this.currentDate.getMonth() - amount);
          } else if (unit === "Y") {
            this.fromDate.setFullYear(this.currentDate.getFullYear() - amount);
          }

          this.toDate = new Date(this.currentDate);
        }
        break;
    }

    this.dateEmitter.emit({
      from_date: this.fromDate,
      to_date: this.toDate,
    });
  }

  onSelectRange() {
    this.model = "custom";
    this.modelChange.emit(this.model);
    this.dateEmitter.emit({
      from_date: this.range.value.start || "",
      to_date: this.range.value.end || "",
    });
  }
}

interface Int_Date {
  from_date: string | Date | null;
  to_date: string | Date | null;
}
